import { CoreLogService } from "../log.service";

/** Splashcreen */

export interface Splashscreen {
  /** Zeigt den Splashscreen an */
  show(): void;

  /** Versteckt den Splashscreen */
  hide(): void;
}

export class SplashscreenDefault implements Splashscreen {

  /** Splashcreen */
  constructor(private _coreLogService: CoreLogService) {
  }

  /** Zeigt den Splashscreen an */
  public show() {
    try {
      navigator.splashscreen.show();
    } catch (ex) {
      this._coreLogService.error("SplashscreenDefault", "Splashscreen konnte nicht angezeigt werden.");
    }
  }

  /** Versteckt den Splashscreen */
  public hide() {
    try {
      navigator.splashscreen.hide();
    } catch (ex) {
      this._coreLogService.error("SplashscreenDefault", "Splashscreen konnte nicht ausgeblendet werden.");
    }
  }
}
